<template slot-scope="scope">
  <!-- 车险活动购买信息弹窗 -->
      <dialogModel
        :title="dialogTitle"
        :visible.sync="dialogPurchase"
        @handleClose="handleClosePurchase"
        @handleOk="handlePurchase"
      >
        <div>
          <div v-if="Select == '1'">
            <p class="Hint-p">
              剩余信息卡{{
                PropNumber
              }}张，此操作将消耗一张信息卡，是否继续操作？
            </p>
          </div>
          <div v-if="Select == '2' || Select == '4'">
            <div class="shield">
              <p><span style="color: red">*</span>企业名称：</p>
              <div>
                <el-select
                  v-model="input1"
                  filterable
                  remote
                  placeholder="请输入关键词"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @change="pestChange"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
import {
  postGetCompanyListByName, // 根据公司名搜索公司
} from "../../../../../assets/api/index";
export default {
  props: {
    dialogPurchase: {},
    Select: {}, // 页面区分 1智能匹配  2分配商机  3转发  4购买
    PropNumber: {}, // 信息卡剩余数量
  },
  components: {},
  data() {
    return {
      input1: "",
      code: "",
      options: [],
      value: [],
      list: [],
      loading: false, // 添加屏蔽公司加载状态
      states: [], // 添加屏蔽公司 公司数据列表
    
    };
  },
  computed: {
    dialogTitle() {
      return this.Select == "1" ? "购买" : "转发";
    }
  },
  created() {},
  methods: {
    // 选择 企业名称完毕 获取需要的值
    pestChange(val) {
      var data = {};
      data.data = {
        name: val,
      };
      postGetCompanyListByName(data, 1, 10).then((res) => {
        // 给添加屏蔽公司接口所需的数据赋值

        this.code = res.data.list[0].id;
      });
    },
    // 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取企业名称放入this.states
      var data = {};
      data.data = {
        name: query,
      };
      if (query !== "") {
        // 调用 获取企业名称接口
        await postGetCompanyListByName(data, 1, 10).then((res) => {
          this.states = res.data.list;
          this.list = this.states.map((item) => {
            return {
              value: `${item.name}`,
              label: `${item.name}`,
              id: `${item.id}`,
            };
          });
        });
        // 组件 自带远程搜索的函数

        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    // 关闭弹窗
    handleClosePurchase() {
      this.$emit("handleClosePurchase");
    },
    handlePurchase() {
      if (this.Select == "1") {
        this.$emit("handlePurchase");
      } else {
        // 转发
        if (this.input1 != "" && this.code != "") {
          this.$emit("handlePurchase" , this.input1 , this.code);
        } else {
           this.$tool.PromptBox("error", "请输入企业名称");
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
// 自我评价输入框的样式
/deep/.el-textarea {
  min-height: 60px !important;
}
/deep/.el-textarea__inner {
  min-height: 80px !important;
}
/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  border: 1px solid #409eff ;
}

.shield {
  width: 450px;
  height: 35px;
  margin: auto;
  display: flex;
  line-height: 35px;
  p {
    min-width: 80px;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
  div {
    flex: 1;
  }
}
</style>
